import { useNavigate, useSearchParams } from "react-router-dom";
import instance, { url } from "../../axios/instance";
import AuthButton from "../../components/buttons/AuthButton";
import { toast } from "react-toastify";
import { saveToken } from "../../utils/token";
import { useEffect, useState } from "react";

export default function AcceptInvitePage() {
  const navigate = useNavigate();
  const [searchParams, setParams] = useSearchParams();
  const token = searchParams.get("token");
  const [isLoading, setIsLoading] = useState(false);
  const [facility, setFacility] = useState(null);
  const [defLoading, setDefLoading] = useState(true);

  useEffect(() => {
    let subscribed = true;
    if (token) {
      setDefLoading(true);
      (async () => {
        try {
          const res = await instance.get("/doctor/facility", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (subscribed) {
            console.log(res.data);
            setDefLoading(false);
            setFacility(res.data);
          }
        } catch (e) {
          console.log(e);
          subscribed && setDefLoading(false);
        }
      })();
    }

    return () => {
      subscribed = false;
    };
  }, [token]);

  const handleAcceptInvite = async () => {
    try {
      setIsLoading(true);
      const response = await instance.post(
        `/doctor/facility/accept-invite`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      saveToken(response.data.ACCESS_TOKEN);
      toast.success("Invite accepted successfully");
      window.location.href = "/clinic/dashboard/overview";
      localStorage.setItem("facility", facility.id);
      localStorage.setItem("CLINIC_LOGO", `${url}${facility.logo_path}`);
      localStorage.setItem("CLINIC_PRIMARY_COLOR", facility.theme_color);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      toast.error(error.response ? error.response.data.message : error.message);
    }
  };

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-xl w-full shadow-xl bg-white p-7 rounded-xl space-y-6">
        {defLoading ? (
          <div className="flex items-center justify-center">
            <div className="w-10 h-10 border-t-transparent border-b-transparent border-r-transparent border-l-primary rounded-full animate-spin border-4"></div>
          </div>
        ) : (
          <>
            {facility ? (
              <>
                <img
                  src={
                    facility?.logo_path
                      ? `${url}${facility?.logo_path}`
                      : "/clinic/images/logo1.png"
                  }
                  className="w-40 mb-4"
                />
                <div>
                  <div className="text-xl font-bold mb-2">
                    Accept {facility?.name} Invite
                  </div>
                  <div className="text-gray-500 text-[14px]">
                    You are invited to join a new practice. Please accept the
                    invite to continue.
                  </div>
                </div>
                <AuthButton
                  title="Accept Invite"
                  onClick={handleAcceptInvite}
                  isLoading={isLoading}
                  width="w-full"
                  style={{
                    backgroundColor: facility?.theme_color,
                  }}
                />
              </>
            ) : (
              <div className="flex items-center justify-center">
                <div className="text-xl font-bold mb-2">
                  No facility found - URL is invalid.
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
